export function openSupport() {
  window.__z2SunCoWidgetRef?.show()
}
